import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import allActions from '../../actions/product_builder';
import buttons from '../../styles/buttons.module.css';
import layout from '../../styles/layout.module.css';
import { IShell } from '../../interfaces/ciem';
import { Dispatch, SetStateAction } from 'react';

interface IShellExcerpt{
    setSelected : Dispatch<SetStateAction<string|null>>;
    shell : IShell;
    currentSide : string;
    isCurrent: boolean;
}
let ShellExcerpt = ({ setSelected, shell, currentSide, isCurrent }: IShellExcerpt) => {
    const dispatch = useDispatch();

    return (
        <Button
            disableRipple={true}
            className={layout.pickerBtnContainer}
            onClick={() => {
                if (currentSide === 'both') {
                    dispatch(allActions.shellActions.setActiveShell(shell));
                    setSelected(shell.displayName);
                } else if (currentSide === 'left') {
                    dispatch(allActions.shellActions.setLeftShell(shell));
                    setSelected(shell.displayName);
                } else {
                    dispatch(allActions.shellActions.setRightShell(shell));
                    setSelected(shell.displayName);
                }
            }}
            onMouseEnter={() => setSelected(shell.displayName)}
            onMouseLeave={() => setSelected(null)}>
            <img
                src={shell.iconImage}
                alt={shell.SK}
                className={isCurrent ? buttons.btnCircleActive : buttons.btnCircle}></img>
        </Button>
    );
};

export default ShellExcerpt;
